import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
// [13/08/2026] Se retiró el import comentado de "aws-sdk/clients/s3": AwsService ya sólo hace llamadas HTTP contra el backend, el manejo de S3 se movió del frontend hace tiempo.
import { environment } from "src/environments/environment";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class AwsService {
  token: string;
  path: string = environment.URL_SERVICIOS.replace("/api/v1", "");
  constructor(public http: HttpClient) {

  }


  /*async uploadFile(file: any, idu: string) {
    const contentType = file.type;
    const bucket = new S3({
      accessKeyId: environment.AWS.accessKeyId,
      secretAccessKey: environment.AWS.secretAccessKey,
      region: environment.AWS.region,
    });
    const params = {
      Bucket: environment.AWS.bucketNomina,
      Key:
        environment.AWS.folder + "documentosProveedor/" + idu + "/" + file.name,
      Body: file,
      ACL: "public-read",
      ContentType: contentType,
    };
    return bucket.upload(params).promise();
  }*/

  /*async delteContributorFile(idu: string, url) {
    const params = {
      Bucket: environment.AWS.bucketNomina,
      Key: url,
    };
    const s3 = new S3({
      accessKeyId: environment.AWS.accessKeyId,
      secretAccessKey: environment.AWS.secretAccessKey,
      region: environment.AWS.region,
    });
    s3.deleteObject(params, function (err, data) {
      console.log(data);
      if (err) console.log(err);
      else console.log("borrado"+params.Key);
    });
  }*/

  async CreatePFcustomer(regUsuario: any, idu: string) {
    let data = {
      company_rfc: regUsuario.datosEmpleoAct.rfcemp,
      type: "customer",
      contributor: {
        contributor_type: "PF",
        bank: regUsuario.egrydatban.nombrebanco,
        account_number: regUsuario.egrydatban.ncuentabanco,
        clabe: regUsuario.egrydatban.clabebanco,
        extra1: regUsuario.egrydatban.extra1,
      },
      contributor_address: {
        municipality_id: regUsuario.datosDomicilio.delymun,
        state_id: regUsuario.datosDomicilio.ciudad,
        address_type: "Fiscal",
        street: regUsuario.datosDomicilio.calle,
        external_number: regUsuario.datosDomicilio.nexterior,
        apartment_number: regUsuario.datosDomicilio.ninterior,
        suburb_type: "Urbano",
        suburb: regUsuario.datosDomicilio.colonia,
        postal_code: regUsuario.datosDomicilio.cp,
        address_reference: regUsuario.datosDomicilio.referencia,
      },
      person: {
        fiscal_regime: "PF",
        rfc: regUsuario.datosPersonales.RFC,
        curp: regUsuario.datosPersonales.CURP,
        imss: regUsuario.datosPersonales.imms,
        first_name: regUsuario.datosPersonales.nombre,
        last_name: regUsuario.datosPersonales.apellidop,
        second_last_name: regUsuario.datosPersonales.apellidom,
        gender: regUsuario.datosPersonales.sexo,
        nationality: regUsuario.datosPersonales.nacionalidad,
        birth_country: regUsuario.datosPersonales.pais,
        birthplace: regUsuario.datosPersonales.paisres,
        birthdate: regUsuario.datosPersonales.fechanacimiento,
        martial_status: regUsuario.datosPersonales.casado,
        id_type: regUsuario.datosPersonales.identificacion,
        identification: regUsuario.datosPersonales.nidentificacion,
        phone: regUsuario.datosDomicilio.telparticular,
        mobile: regUsuario.datosDomicilio.telmovil,
        email: regUsuario.datosDomicilio.mailface,
        martial_regime: regUsuario.datosPersonales.regimen,
        minior_dependents: regUsuario.datosPersonales.menores,
        senior_dependents: regUsuario.datosPersonales.mayores,
        housing_type: regUsuario.datosDomicilio.tvivienda,
        extra3: regUsuario.datosCredito.destino
      },
      customer: {
        customer_type: "EMPLEADO",
        status: "AC",
        attached: "",
        user_id: idu,
        seniority: regUsuario.datosLaborales.antiguedad,
        immediate_superior: regUsuario.datosLaborales.jefe,
        salary: regUsuario.egrydatban.sueldomens,
        salary_period: regUsuario.datosLaborales.formaPago,
        company_id: regUsuario.datosEmpleoAct.companyid,
        other_income: regUsuario.egrydatban.oingresos,
        total_income: regUsuario.egrydatban.supertotal,
        house_rent: regUsuario.datosDomicilio.house_rent,
        extra3: regUsuario.datosEmpleoAct.extra3,
        ontime_bonus: regUsuario.egrydatban.bpuntualidad,
        assist_bonus: regUsuario.egrydatban.basistencia,
        food_vouchers: regUsuario.egrydatban.valesdespensa,
        taxes: regUsuario.egrydatban.impuestos,
        imms: regUsuario.egrydatban.retimss,
        savings_found: regUsuario.egrydatban.fahorro,
        savings_found_loand: regUsuario.egrydatban.pfahorro,
        savings_bank: regUsuario.egrydatban.cajaahorro,
        insurance_discount: regUsuario.egrydatban.dseguro,
        extra_expenses: regUsuario.egrydatban.extraordinario,
        infonavit: regUsuario.egrydatban.infonavit,
        child_support: regUsuario.egrydatban.palimentaria,
        public_charge : regUsuario.kyc.public_charge,
        public_charge_det : regUsuario.kyc.public_charge_det,
        relative_charge : regUsuario.kyc.relative_charge,
        relative_charge_det : regUsuario.kyc.relative_charge_det,
        benefit: regUsuario.kyc.benefit,
        benefit_detail: regUsuario.kyc.benefit_detail,
        responsible: regUsuario.kyc.responsible,
        responsible_detail: regUsuario.kyc.responsible_detail
      },
      customer_personal_references: [
        {
          first_name: regUsuario.refPers.nombrenf1,
          last_name: regUsuario.refPers.apellidopnf1,
          second_last_name: regUsuario.refPers.apellidomnf1,
          address: regUsuario.refPers.domnf1,
          phone: regUsuario.refPers.telnf1,
          reference_type: "No familiar",
        },
        {
          first_name: regUsuario.refPers.nombrenf2,
          last_name: regUsuario.refPers.apellidopnf2,
          second_last_name: regUsuario.refPers.apellidomnf2,
          address: regUsuario.refPers.domnf2,
          phone: regUsuario.refPers.telnf2,
          reference_type: "No familiar",
        },
        {
          first_name: regUsuario.refPers.nombrefam,
          last_name: regUsuario.refPers.apellidopfam,
          second_last_name: regUsuario.refPers.apellidomfam,
          address: regUsuario.refPers.domfam,
          phone: regUsuario.refPers.telfam,
          reference_type: "Familiar",
        },
      ],
    };
    const url = `${environment.URL_SERVICIOS}/user_registration?`;
    return this.http.post(url, data).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  async PatchDatosFamiliares(dataref) {
    const url = `${environment.URL_SERVICIOS}/user_update/update_user_info`;
    return this.http.patch(url, dataref).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  async PatchPFcustomer(regUsuario: any) {
    const url = `${environment.URL_SERVICIOS}/user_update/update_user_info`;
    let dataref = {
      person_id: regUsuario.datosEspeciales.person_id,
      customer_pr_id: regUsuario.refPers[0].idcontrolnf1,
      person: {
        imss: regUsuario.datosPersonales.imms
            },
    customer_personal_reference: 
        {
          first_name: regUsuario.refPers[0].nombrenf1,
          last_name: regUsuario.refPers[0].apellidopnf1,
          second_last_name: regUsuario.refPers[0].apellidomnf1,
          address: regUsuario.refPers[0].domnf1,
          phone: regUsuario.refPers[0].telnf1,
          reference_type: "No familiar"
        }
    }
    await (await this.PatchDatosFamiliares(dataref)).toPromise();
    dataref.customer_pr_id = regUsuario.refPers[1].idcontrolnf2;
    dataref.customer_personal_reference.first_name = regUsuario.refPers[1].nombrenf2;
    dataref.customer_personal_reference.last_name = regUsuario.refPers[1].apellidopnf2;
    dataref.customer_personal_reference.second_last_name = regUsuario.refPers[1].apellidomnf2;
    dataref.customer_personal_reference.address = regUsuario.refPers[1].domnf2
    dataref.customer_personal_reference.phone = regUsuario.refPers[1].telnf2
    dataref.customer_personal_reference.reference_type = "No familiar"
    await (await this.PatchDatosFamiliares(dataref)).toPromise();
    dataref.customer_pr_id = regUsuario.refPers[2].idcontrolfam;
    dataref.customer_personal_reference.first_name = regUsuario.refPers[2].nombrefam;
    dataref.customer_personal_reference.last_name = regUsuario.refPers[2].apellidopfam;
    dataref.customer_personal_reference.second_last_name = regUsuario.refPers[2].apellidomfam;
    dataref.customer_personal_reference.address = regUsuario.refPers[2].domfam
    dataref.customer_personal_reference.phone = regUsuario.refPers[2].telfam
    dataref.customer_personal_reference.reference_type = "Familiar"
    await (await this.PatchDatosFamiliares(dataref)).toPromise();
    let data = {
      person_id: regUsuario.datosEspeciales.person_id,
      contributor_id: regUsuario.datosEspeciales.contributor_id,
      customer_id: regUsuario.datosEspeciales.customer_id,
      contributor_address_id: regUsuario.datosEspeciales.contributor_addres_id,
      //customer_pr_id: regUsuario.datosEspeciales.customer_pr_id,
      contributor: {
        bank: regUsuario.egrydatban.nombrebanco,
        account_number: regUsuario.egrydatban.ncuentabanco,
        clabe: regUsuario.egrydatban.clabebanco,
        extra1: regUsuario.egrydatban.extra1,
      },
      contributor_address: {
        municipality_id: regUsuario.datosDomicilio.delymun,
        state_id: regUsuario.datosDomicilio.ciudad,
        street: regUsuario.datosDomicilio.calle,
        external_number: regUsuario.datosDomicilio.nexterior,
        apartment_number: regUsuario.datosDomicilio.ninterior,
        suburb: regUsuario.datosDomicilio.colonia,
        postal_code: regUsuario.datosDomicilio.cp,
        address_reference: regUsuario.datosDomicilio.referencia,
      },
      person: {
        rfc: regUsuario.datosPersonales.RFC,
        curp: regUsuario.datosPersonales.CURP,
        imss: regUsuario.datosPersonales.imms,
        first_name: regUsuario.datosPersonales.nombre,
        last_name: regUsuario.datosPersonales.apellidop,
        second_last_name: regUsuario.datosPersonales.apellidom,
        gender: regUsuario.datosPersonales.sexo,
        nationality: regUsuario.datosPersonales.nacionalidad,
        birth_country: regUsuario.datosPersonales.pais,
        birthplace: regUsuario.datosPersonales.paisres,
        birthdate: regUsuario.datosPersonales.fechanacimiento,
        martial_status: regUsuario.datosPersonales.casado,
        id_type: regUsuario.datosPersonales.identificacion,
        identification: regUsuario.datosPersonales.nidentificacion,
        phone: regUsuario.datosDomicilio.telparticular,
        mobile: regUsuario.datosDomicilio.telmovil,
        email: regUsuario.datosDomicilio.mailface,
        martial_regime: regUsuario.datosPersonales.regimen,
        minior_dependents: regUsuario.datosPersonales.menores,
        senior_dependents: regUsuario.datosPersonales.mayores,
        housing_type: regUsuario.datosDomicilio.tvivienda,
      },
      customer: {
        seniority: regUsuario.datosLaborales.antiguedad,
        immediate_superior: regUsuario.datosLaborales.jefe,
        salary: regUsuario.egrydatban.sueldomens,
        salary_period: regUsuario.datosLaborales.formaPago,
        company_id: regUsuario.datosEmpleoAct.companyid,
        other_income: regUsuario.egrydatban.oingresos,
        total_income: regUsuario.egrydatban.supertotal,
        house_rent: regUsuario.datosDomicilio.house_rent,
        extra3: regUsuario.datosEmpleoAct.extra3,
        ontime_bonus: regUsuario.egrydatban.bpuntualidad,
        assist_bonus: regUsuario.egrydatban.basistencia,
        food_vouchers: regUsuario.egrydatban.valesdespensa,
        taxes: regUsuario.egrydatban.impuestos,
        imms: regUsuario.egrydatban.retimss,
        savings_found: regUsuario.egrydatban.fahorro,
        savings_found_loand: regUsuario.egrydatban.pfahorro,
        savings_bank: regUsuario.egrydatban.cajaahorro,
        insurance_discount: regUsuario.egrydatban.dseguro,
        extra_expenses: regUsuario.egrydatban.extraordinario,
        infonavit: regUsuario.egrydatban.infonavit,
        child_support: regUsuario.egrydatban.palimentaria,
        public_charge : regUsuario.kyc.public_charge,
        public_charge_det : regUsuario.kyc.public_charge_det,
        relative_charge : regUsuario.kyc.relative_charge,
        relative_charge_det : regUsuario.kyc.relative_charge_det,
        benefit: regUsuario.kyc.benefit,
        benefit_detail: regUsuario.kyc.benefit_detail,
        responsible: regUsuario.kyc.responsible,
        responsible_detail: regUsuario.kyc.responsible_detail
      },
      /*customer_personal_references: [
        {
          first_name: regUsuario.refPers.nombrenf1,
          last_name: regUsuario.refPers.apellidopnf1,
          second_last_name: regUsuario.refPers.apellidomnf1,
          address: regUsuario.refPers.domnf1,
          phone: regUsuario.refPers.telnf1,
          reference_type: "No familiar",
        },
        {
          first_name: regUsuario.refPers.nombrenf2,
          last_name: regUsuario.refPers.apellidopnf2,
          second_last_name: regUsuario.refPers.apellidomnf2,
          address: regUsuario.refPers.domnf2,
          phone: regUsuario.refPers.telnf2,
          reference_type: "No familiar",
        },
        {
          first_name: regUsuario.refPers.nombrefam,
          last_name: regUsuario.refPers.apellidopfam,
          second_last_name: regUsuario.refPers.apellidomfam,
          address: regUsuario.refPers.domfam,
          phone: regUsuario.refPers.telfam,
          reference_type: "Familiar",
        },
      ], */
    };
    
    return this.http.patch(url, data).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  async PatchPFcustomerConsulta(person_id: string, fname: string) {
    const url = `${environment.URL_SERVICIOS}/user_update/update_user_info?person_id=${person_id}&person[first_name]=${fname}`;
    return this.http.patch(url, null).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  patchUrl(idc, idd, urldoc) {
    let params = {
      url: urldoc,
      status: "IN",
    };
    const url = `${environment.URL_SERVICIOS}/contributors/${idc}/contributor_documents/${idd}?`;
    return this.http.patch(url, params).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

   patchUrlreemplazo(idc, idd) {
    let params = {
      url: null,
      status: "PI",
    };
    const url = `${environment.URL_SERVICIOS}/contributors/${idc}/contributor_documents/${idd}?`;
    return this.http.patch(url, params).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  async creauserprueba() {
    const url = "https://run.mocky.io/v3/83b3108b-d56f-4473-be80-546464d10cae";
    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  getDocuments(idu: string) {
    const url = `${environment.URL_SERVICIOS}/contributor_documents/get_contributor_documents?contributor_id=${idu}`;
    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  getDocumentsClient(idu: string) {
    let cliente = 'CLIENTE';
    const url = `${environment.URL_SERVICIOS}/contributor_documents/get_contributor_documents?contributor_id=${idu}&document_client=${cliente}`;
    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  getUserDocuments(idu: string) {
    const url = `${environment.URL_SERVICIOS}/contributors/${idu}/contributor_documents`;
    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  async getDocuments2(idu: string) {
    const url = `${this.path}/contributor_documents?id=${idu}`;
    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  getCountries() {
    const url = `${environment.URL_SERVICIOS}/countries`;

    return this.http.get(url).pipe(
      map((resp: any) => {
        return this.crearArregloStates(resp['data']);
      })
    );
  }

  getCountriesD() {
    const url = `${environment.URL_SERVICIOS}/countries`;

    return this.http.get(url).pipe(
      map((resp: any) => {
        let countries = [];
        resp.data.forEach(element => {
          countries.push(element.attributes)
        });
        return countries;
      })
    );
  }

  getStatesId(id) {
    const url = `${environment.URL_SERVICIOS}/countries/${id}/states`;

    return this.http.get(url).pipe(
      map((resp: any) => {
        return this.crearArregloStates(resp);
      })
    );
  }

  getStates() {
    const url = `${environment.URL_SERVICIOS}/countries/83826a4b-af0e-4bdf-b7b8-0b123abe79b1/states`;

    return this.http.get(url).pipe(
      map((resp: any) => {
        return this.crearArregloStates(resp);
      })
    );
  }

  getMunicipios(idm) {
    const url = `${environment.URL_SERVICIOS}/states/${idm}/municipalities`;

    return this.http.get(url).pipe(
      map((resp: any) => {
        return this.crearArregloStates(resp);
      })
    );
  }

  getColoniasxcp(cp) {
    const url = `${environment.URL_SERVICIOS}/postal_codes/pc/${cp}`;

    return this.http.get(url).pipe(
      map((resp: any) => {
        return this.crearArregloStates(resp);
      })
    );
  }

  crearArregloStates(contribuObj: any) {
    const rr: any[] = [];
    const resul: any[] = [];
    if (contribuObj === null) {
      return [];
    }
    Object.keys(contribuObj).forEach((key) => {
      const rol: any = contribuObj[key];
      rr.push(rol);
    });
    // tslint:disable-next-line: forin
    for (const prop in rr[0]) {
      resul.push(rr[0][prop].attributes);
    }

    return resul;
  }

  pruebacopa() {
    let headers = new HttpHeaders({
      Authorization: "743CEB35-0992-E14E-B0180BAB439ED2A7",
    });
    let options = { headers: headers };
    let body = {
      uuid: "5AB0CE61-FE49-463A-AD1F-DDF02FD9E0DB",
      importe: 141725.63,
    };
    const url = `https://link.copachisa.com/link2/_ws/pagos.cfc?method=actualizaPago`;
    return this.http.post(url, body, options).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  async registroPagos(data) {
    let taresp: any[] = [];
    console.log(data);
    for await (let prop of data) {
      try {
        const r = "correcto";
        let resp = {
          status: true,
          resp: r,
          cc: prop.CLAVE_CREDITO,
          msg: "Pago registrado",
        };
        taresp.push(resp);
      } catch (error) {
        console.log(error);
        let resp = {
          status: false,
          resp: error,
          msg: "Error en el pago",
        };
        taresp.push(resp);
      }
    }
    return taresp;
  }

  getCompanyByUser(uid: string) {
    const url = `${environment.URL_SERVICIOS}/reports/user_id/${uid}/user_company`;
    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  crearArregloList(contribuObj: any) {
    const rr: any[] = [];
    const resul: any[] = [];
    if (contribuObj === null) {
      return [];
    }
    Object.keys(contribuObj).forEach((key) => {
      const rol: any = contribuObj[key];
      rr.push(rol);
    });
    // tslint:disable-next-line: forin
    for (const prop in rr[0]) {
      resul.push([rr[0][prop].attributes.value, rr[0][prop].attributes.key]);
    }
    return resul;
  }

  getUserGender() {
    const url = `${environment.URL_SERVICIOS}/lists/domain/PERSON_GENDER`;
    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  getKeyAlsuper() {
    const url = `${environment.URL_SERVICIOS}/lists/domain/ALSUPER`;
    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  getPersonBank() {
    const url = `${environment.URL_SERVICIOS}/lists/domain/PERSON_BANK`;
    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  getCompanyes() {
    const url = `${environment.URL_SERVICIOS}/reports/get_company`;
    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  getInfoRegEmp(idu: string) {
    const url = `${environment.URL_SERVICIOS}/reports/user_id/${idu}/get_user_registration`;
    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  getInfoRefPers(idu: string) {
    const url = `${environment.URL_SERVICIOS}/reports/user_id/${idu}/get_customer_pr`;
    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  getContributorDocuments(idc) {
    const url = `${environment.URL_SERVICIOS}/contributors/${idc}/contributor_documents`;
    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  getInfoEmpNss(nss: string) {
    const url = `${environment.URL_SERVICIOS}/listado_alsupers/get_empleado_by_nss/${nss}`;
    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }
}
